import { z } from "zod";

export const CancelStudentPackageSchema = z.object({
  cancelReason: z.string().min(1, "ກະລຸນາປ້ອນໝາຍເຫດ"),
});

export type CancelStudentPackageDTO = z.infer<typeof CancelStudentPackageSchema>;
